import type { StatsActivityItem } from './statsService';

export interface DailyActivity {
    id: string;
    /** English label from the API ("Today", …); only a fallback for an API without days_ago. */
    period: string;
    /** 0 = today, 1 = yesterday, … Formatted in the interface language. */
    daysAgo?: number;
    addedCount: number;
    reviewedCount: number;
    collectionsCreated: number;
    type: 'daily' | 'collection';
    collectionName?: string;
}

export const activityService = {
    /** Pure mapper, not a fetch — `activity_items` is part of the shared
     * /api/v1/stats/overview response (see StatsRefreshContext), so there's nothing left to
     * fetch here. Previously this re-fetched both user settings (just for learning_language)
     * and the overview itself, duplicating requests every other overview consumer already made. */
    mapActivityItems: (items: StatsActivityItem[] | null | undefined): DailyActivity[] => {
        return (items ?? []).map((item) => ({
            id: item.id,
            period: item.period,
            daysAgo: item.days_ago,
            addedCount: item.added_count,
            reviewedCount: item.reviewed_count,
            collectionsCreated: item.collections_created,
            type: item.type === 'collection' ? 'collection' : 'daily',
            collectionName: item.collection_name,
        }));
    },
};
